import "./fontawesome"; // Must be first - FontAwesome config before any icons are used
import React from "react";
import ReactDOM from "react-dom/client";

import * as Sentry from "@sentry/react";

import { worker as serverWorker } from "@/mocks/browser";
import { PARSED_ENV } from "@/constants/common";

import { buildSentryInitOptions } from "./utils/sentryInitOptions";
import { installStaleChunkReload } from "./utils/staleChunkReload";

import "src/utils/string.extensions";

import App from "./App";

PARSED_ENV.VITE_NODE_ENV !== "development" &&
	!PARSED_ENV.VITE_API_URL.includes("localhost") &&
	Sentry.init(buildSentryInitOptions());

// A tab left open across a deploy reloads once instead of failing on a chunk that is gone (PREC-4387).
installStaleChunkReload();

if (PARSED_ENV.VITE_NODE_ENV === "development") {
	serverWorker.start();
}

const root = ReactDOM.createRoot(document.getElementById("root") as HTMLElement);

root.render(
	// <React.StrictMode>
	<App />
	// </React.StrictMode>
);
